var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L26.4 0 26.4 26.4 0 26.4z",
    transform: "translate(-2.1 -1.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M4.683 6.238l2.35 2.35c-2.418 3.235-1.927 7.789 1.126 10.433s7.63 2.48 10.486-.376c2.855-2.856 3.02-7.433.376-10.486-2.644-3.053-7.198-3.544-10.432-1.126l-2.352-2.35C8.2 3.073 10.661 2.196 13.2 2.2c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11c0-2.641.93-5.065 2.483-6.962zm3.928 3.93l4.589 4.587 1.555-1.555-4.588-4.59c2.356-1.556 5.508-1.077 7.293 1.11 1.786 2.188 1.626 5.372-.37 7.368-1.997 1.997-5.181 2.157-7.368.371-2.188-1.786-2.667-4.937-1.11-7.293l-.001.001z",
    transform: "translate(-2.1 -1.3)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar);
export default __webpack_public_path__ + "static/media/radar.5397651939025f0d3c18bb6f3d8b5895.svg";
export { ForwardRef as ReactComponent };